import { Injectable } from '@angular/core';
import { HttpDataService } from '../shared/http/http-data.service';
import { ICompany, ISubCompany, IValueObject, IWebshop } from '../../type_definitions/datatypes';

export interface ISetPasswordResponse {
  token:string;
}

export interface ISignUpRequest {
  email:string;
  firstname:string;
  lastname:string;
  subCompany:string;
  company:string;
  country:number;
  accountType:IValueObject;
  role?:string;
  comment?:string;
}

export interface ISignUpResponse {
  sentToApprover:boolean;
}

export interface ISignupContext {
  company:ICompany;
  subCompany:ISubCompany;
  webshop:IWebshop;
  email?:string;
}

@Injectable()
export class AccessDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public sendPasswordResetLink(email:string):Promise<any> {
    return this.httpDataService.doPOST(
      `rest/userman/forgotpassword`,
      undefined,
      { email },
      undefined,
      'Error sending password reset link'
    );
  }

  public setPassword(newPassword:string):Promise<ISetPasswordResponse> {
    return this.httpDataService.doPOST(
      `rest/userman/setpassword`,
      undefined,
      { newPassword },
      undefined,
      'Error resetting password'
    );
  }

  public signUp(userData:ISignUpRequest, contextId:string):Promise<ISignUpResponse> {
    return this.httpDataService.doPOST(
      `rest/userman/signup`,
      { contextId },
      userData
    );
  }

  public loadSignupContext(contextId:string):Promise<ISignupContext> {
    return this.httpDataService.doGET(
      'rest/userman/context',
      { contextId },
      undefined,
      'Error loading context'
    );
  }
}